module.exports = __webpack_public_path__ + "static/media/classic_phone.ad11bb53.mp3";